import { SCREEN } from "../../utils/constants";
import { navigate } from "./movePages";

export function appointmentCancelListeners() {
    setupBookNewAppointmentListener();
}

function setupBookNewAppointmentListener() {
    const bookNewButton = document.getElementById('book-new-appointment-btn');
    if (bookNewButton) {
        bookNewButton.addEventListener('click', handleBookNewAppointment);
    }
}

function handleBookNewAppointment() {
    // Navigate back to the main menu or booking flow
    navigate(SCREEN.DASHBOARD);
}
